var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09661 1.2672C7.48713 1.65772 7.48713 2.29089 7.09661 2.68141L3.4142 6.36383L13.7277 6.3639C14.28 6.36391 14.7277 6.81163 14.7277 7.36391C14.7277 7.9162 14.28 8.36391 13.7277 8.3639L3.41423 8.36383L7.09661 12.0462C7.48713 12.4367 7.48713 13.0699 7.09661 13.4604C6.70609 13.8509 6.07292 13.8509 5.6824 13.4604L0.292893 8.07091C-0.0976311 7.68039 -0.0976311 7.04723 0.292893 6.6567L5.6824 1.2672C6.07292 0.876673 6.70609 0.876673 7.09661 1.2672Z",
    fill: "#40A9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.b0a61750b8edb5d9fce9ca71c1598950.svg";
export { ForwardRef as ReactComponent };